// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3AL5v","info":"Note_info__2UIlo","note":"Note_note__-bRRq","actions":"Note_actions__3lYir"};